import React, { lazy } from 'react';
import * as HiIcons from 'react-icons/hi';
import * as FaIcons from 'react-icons/fa';
import { MdSettings } from 'react-icons/md';
import { IoMdLink } from 'react-icons/io';
import { GiPlanetCore, GiOrbDirection } from 'react-icons/gi';
import BusinessProfile from '../../../screens/Dashboard/Screens/Settings/BusinessProfile/BusinessProfile';
import UserProfile from '../../../screens/Dashboard/Screens/Settings/UserProfile/UserProfile';
import ApiMerchantCode from '../../../screens/Dashboard/Screens/Settings/api_merchant_code';
import BankAccounts from '../../../screens/Dashboard/Screens/Settings/BankAccounts';
import User from '../../../screens/Dashboard/Screens/Settings/User/User';
import TwoFactorAuth from '../../../screens/Dashboard/Screens/Settings/Security/TwoFactorAuth';
import SplitPaymentDetail from '../../../screens/Dashboard/Screens/SplitPayment/SplitPaymentDetail';
import TaxIdTab from '../../../screens/Dashboard/Screens/Settings/TaxID/TaxID';

const Login = lazy(() => import('../../../screens/Auth/Login/Login'));
const Register = lazy(() => import('../../../screens/Auth/Signup/Register'));
const Invitation = lazy(() => import('../../../screens/Auth/Invitation/Invitation'));
const RequestReset = lazy(() => import('../../../screens/Auth/Request-Reset/request-reset'));
const Overview = lazy(() => import('../../../screens/Dashboard/Screens/Overview'));
const Transactions = lazy(() => import('../../../screens/Transactions/index'));
const TermsOfUse = lazy(() => import('../../components/terms_of_use'));
const ResetPassword = lazy(() => import('../../../screens/Auth/Reset-Password/reset-password'));
const Customers = lazy(() => import('../../../screens/Dashboard/Screens/Customers'));
const Payouts = lazy(() => import('../../../screens/Dashboard/Screens/Payouts'));
const Plans = lazy(() => import('../../../screens/Plans'));
const Invoices = lazy(() => import('../../../screens/Invoices'));
const GoLive = lazy(() => import('../../../screens/go_live'));
const AddInvoiceItemForm = lazy(() => import('../../../screens/Invoices/Forms/AddInvoiceItem'));
const PaymentLink = lazy(() => import('../../../screens/Dashboard/Screens/PaymentLinks'));
const DirectDebit = lazy(() => import('../../../screens/directDebit'));
const Home = lazy(() => import('../../../modules/public/home/Home'));
const AboutUs = lazy(() => import('../../../modules/public/about'));
const PricingHome = lazy(() => import('../../../modules/public/pricing/pricingHome'));
const EndToEndHome = lazy(() => import('../../../modules/public/whySpay/ent2end/EndToEndHome'));
const NoCodingHome = lazy(() => import('../../../modules/public/whySpay/Nocode/NoCodingHome'));
const PaymentSimplifiedHome = lazy(() =>
    import('../../../modules/public/whySpay/PaymentSimplified/PaymentSimplifiedHome')
);
const SpayHelpHome = lazy(() => import('../../../modules/public/support/spayhelp/SpayHelpHome'));
const SpayFaqHome = lazy(() => import('../../../modules/public/support/spayFaq/SpayFaqHome'));
const SpayContactHome = lazy(() => import('../../../modules/public/support/spaycontact/SpayContactHome'));
const SpayHelpcenterHome = lazy(() =>
    import('../../../modules/public/support/spaycontact/spayhelpcenter/SpayHelpcenterHome')
);
const SpaySalesFormHome = lazy(() => import('../../../modules/public/support/spaycontact/spaysales/SpaySalesFormHome'));
const Onboarding = lazy(() => import('../../../screens/Dashboard/Screens/Onboarding'));
const Loader = lazy(() => import('../../components/PageLoader'));
const Settings = lazy(() => import('../../../screens/Dashboard/Screens/Settings'));
const TransactionDetail = lazy(() => import('../../../screens/Transactions/TransactionDetail'));
const CustomerDetail = lazy(() => import('../../../screens/Dashboard/Screens/Customers/CustomerDetail'));
const PaymentDetails = lazy(() => import('../../../screens/PaymentLinks/PaymentDetails'));
const PlanDetail = lazy(() => import('../../../screens/Plans/PlanDetail'));
const InvoicePage = lazy(() => import('../../../screens/Invoices/Views/InvoicePage'));
const PayoutsDetails = lazy(() => import('../../../screens/Dashboard/Screens/Payouts/PayoutsDetail/index'));
const SingleDirectDebit = lazy(() => import('../../../screens/singleDirectDebit'));
const VerifyEmail = lazy(() => import('../../../screens/verify_email'));
const TransferDetail = lazy(() => import('../../components/TransferDetail'));
const AddBusiness = lazy(() => import('../../../screens/Dashboard/Screens/AddBusiness'));

// General Routes
const general = [
    { path: '/register', component: () => <Register /> },
    { path: '/request', component: () => <RequestReset /> },
    { path: '/reset-password/:id', component: () => <ResetPassword /> },
    { path: '/terms-and-conditions', component: () => <TermsOfUse /> },
    { path: '/verify-email/:token', component: () => <VerifyEmail /> },
    { path: '/invitation', component: () => <Invitation /> },
    { path: '/page', component: () => <Loader /> }
];

const overviewRoute = {
    label: {
        name: ''
    },
    content: [
        {
            path: '/dashboard',
            name: 'Overview',
            icon: <HiIcons.HiViewBoards />,
            exact: true,
            component: props => <Overview {...props} />
        }
    ]
};

const businessRoute = {
    label: {
        name: 'Business'
    },
    content: [
        {
            path: '/transactions',
            name: 'Transactions',
            icon: <FaIcons.FaCreditCard />,
            exact: true,
            component: props => <Transactions {...props} />
        },
        {
            path: '/customers',
            name: 'Customers',
            icon: <FaIcons.FaUserAlt />,
            exact: true,
            component: props => <Customers {...props} />
        },
        {
            path: '/payouts',
            name: 'Settlements',
            icon: <FaIcons.FaReceipt className="u-rotate90deg" />,
            exact: true,
            component: props => <Payouts {...props} />
        }
        // {
        //     path: '/balance',
        //     name: 'Balance',
        //     icon: <BsWallet />,
        //     exact: true,
        //     component: props => <Balance {...props} />
        // },
        // {
        //     path: '/sub-account',
        //     name: 'Sub Account',
        //     icon: <GrIcons.GrStackOverflow />,
        //     exact: true,
        //     component: props => <SubAccounts {...props} />
        // }
    ]
};

// const paymentRoute = {
//     label: {
//         name: 'Payments'
//     },
//     content: [
//         // {
//         //     path: '/transfers',
//         //     name: 'Transfers',
//         //     icon: <FaIcons.FaMoneyCheckAlt />,
//         //     exact: true,
//         //     component: props => <Transfers {...props} />
//         // },
//         // {
//         //     path: '/split-payment',
//         //     name: 'Split Payment',
//         //     icon: <AiIcons.AiFillGolden />,
//         //     exact: true,
//         //     component: props => <SplitPayment {...props} />
//         // },
//     ]
// };

const recurringRoute = {
    label: {
        name: 'Recurring'
    },
    content: [
        {
            path: '/plans',
            name: 'Plans',
            icon: <GiPlanetCore />,
            exact: true,
            component: props => <Plans {...props} />
        },
        {
            path: '/directDebit',
            name: 'Direct Debit',
            icon: <GiOrbDirection />,
            exact: true,
            component: props => <DirectDebit />
        }
        // {
        //     path: '/subscribers',
        //     name: 'Subscribers',
        //     icon: <FaIcons.FaMoneyCheckAlt />,
        //     exact: true,
        //     component: props => <Subscribers {...props} />
        // }
    ]
};

const collectionRoute = {
    label: {
        name: 'Collections'
    },
    content: [
        {
            path: '/payment-link',
            name: 'Payment Links',
            icon: <IoMdLink />,
            exact: true,
            component: props => <PaymentLink {...props} />
        },
        {
            path: '/invoice',
            name: 'Invoices',
            icon: <FaIcons.FaMoneyCheckAlt />,
            exact: true,
            component: props => <Invoices {...props} />
        }
    ]
};

const customNav = [overviewRoute, businessRoute, collectionRoute, recurringRoute];

// Sidebar Settings Route
const sidebarBottom = [
    {
        path: '/settings/business-profile',
        name: 'Settings',
        icon: <MdSettings />
    }
];

// Nested Settings Routes
/* For routes under settings alone */
const nestedSettings = [
    {
        path: '/settings/user-profile',
        exact: true,
        name: 'User Profile',
        group: 'profile',
        component: props => <UserProfile {...props} />
    },
    {
        path: '/settings/business-profile',
        exact: true,
        name: 'Business Profile',
        group: 'profile',
        component: props => <BusinessProfile {...props} />
    },
    {
        path: '/settings/bank-accounts',
        exact: true,
        name: 'Bank Accounts',
        group: 'financial',
        component: props => <BankAccounts {...props} />
    },
    {
        path: '/settings/tax-id/:taxId?',
        exact: false,
        name: 'Tax ID',
        group: 'financial',
        component: props => <TaxIdTab {...props} />
    },
    {
        path: '/settings/api-webhooks',
        name: 'Api keys & Merchant Code',
        exact: true,
        group: 'developer',
        component: props => <ApiMerchantCode {...props} />
    },
    {
        path: '/settings/User',
        exact: true,
        name: 'User Management',
        group: 'access',
        component: props => <User {...props} />
    },
    {
        path: '/settings/security',
        exact: true,
        name: 'Security',
        group: 'access',
        component: () => <TwoFactorAuth />
    },
    // {
    //     path: '/settings/team',
    //     name: 'Team',
    //     exact: true,
    //     component: props => <TeamMember {...props} />
    // }
    // {
    //     path: '/settings/preferences',
    //     name: 'Preferences',
    //     exact: true,
    //     component: props => <Preference {...props} />
    // }
];

const authProtectedRoutes = [
    { path: '/onboarding', exact: true, component: props => <Onboarding {...props} /> },
    { path: '/dashboard', exact: true, component: () => <Overview /> },
    { path: '/settings/:menu', component: props => <Settings {...props} /> },
    ...overviewRoute.content,
    ...businessRoute.content,
    ...collectionRoute.content,
    ...recurringRoute.content,
    ...nestedSettings,
    { path: '/payment-link/:id', component: props => <PaymentDetails {...props} /> },
    { path: '/directDebit/:slug', component: props => <SingleDirectDebit {...props} /> },
    // { path: '/payment-page', component: props => <PaymentPage {...props} /> },
    { path: '/transactions/:transactionId', component: props => <TransactionDetail {...props} /> },
    { path: '/customers/:customerId', component: props => <CustomerDetail {...props} /> },
    { path: '/transfer-detail', component: props => <TransferDetail {...props} /> },
    { path: '/split-payment-detail', component: props => <SplitPaymentDetail {...props} /> },
    { path: '/plans/:planId', component: props => <PlanDetail {...props} /> },
    // { path: '/subscriber-detail', component: props => <SubscriberDetail {...props} /> },
    { path: '/add-business', component: props => <AddBusiness /> },
    { path: '/add-item-form', component: props => <AddInvoiceItemForm /> },
    { path: '/invoice_page/:invoiceId', component: props => <InvoicePage {...props} /> },
    { path: '/payouts/:id/:transactionDate', component: props => <PayoutsDetails {...props} /> },
    { path: '/go-live', component: props => <GoLive {...props} /> }
];

// Public Routes
const publicRoutes = [
    // // OUTHER NAVIGATION
    // { path: '/Spay-Pricing', exact: true, component: () => <PricingHome /> },

    // // WHY SPAY LINKS
    // { path: '/end-to-end', exact: true, component: () => <EndToEndHome /> },
    // { path: '/No-Coding', exact: true, component: () => <NoCodingHome /> },
    // {
    //     path: '/Payment-Simplified',
    //     exact: true,
    //     component: () => <PaymentSimplifiedHome />
    // },

    // // SUPPORT LINKS
    // { path: '/spay-help', exact: true, component: () => <SpayHelpHome /> },
    // { path: '/faq', exact: true, component: () => <SpayFaqHome /> },
    // { path: '/Contact', exact: true, component: () => <SpayContactHome /> },
    // {
    //     path: '/Sales-Form',
    //     exact: true,
    //     component: () => <SpaySalesFormHome />
    // },
    // {
    //     path: '/about',
    //     exact: true,
    //     component: () => <AboutUs />
    // },
    // {
    //     path: '/help-and-support',
    //     exact: true,
    //     component: () => <SpayHelpcenterHome />
    // },
    { path: '/', exact: true, component: () => <Login /> }
];

export { authProtectedRoutes, publicRoutes, general, nestedSettings, sidebarBottom, overviewRoute, customNav };
